<template>
  <v-container class="py-0 px-5">
    <v-row dense>
      <v-col cols="12">
        <date-field
          v-model="operatingDay.start"
          autofocus
          field-name="date"
          rules="required"
        />
      </v-col>
      <v-col cols="12" md="6">
        <data-selector
          v-model="operatingDay.coordinator_id"
          field-name="coordinator_id"
          source-type="users"
          rules=""
        />
      </v-col>
      <v-col cols="12" md="6">
        <data-selector
          v-model="operatingDay.assistant_coordinator_id"
          field-name="assistant_coordinator_id"
          source-type="users"
          rules=""
        />
      </v-col>
      <v-col cols="12" md="6">
        <data-selector
          v-model="operatingDay.winch_operator_id"
          field-name="winch_operator_id"
          source-type="users"
          rules=""
        />
      </v-col>
      <v-col cols="12" md="6">
        <data-selector
          v-model="operatingDay.winch_trainee_id"
          field-name="winch_trainee_id"
          source-type="users"
          rules=""
        />
      </v-col>
      <v-col cols="12" md="6">
        <data-selector
          v-model="operatingDay.instructor_igt1_id"
          field-name="instructor_igt1_id"
          source-type="instructors"
          rules=""
        />
      </v-col>
      <v-col cols="12" md="6">
        <data-selector
          v-model="operatingDay.instructor_igt2_id"
          field-name="instructor_igt2_id"
          source-type="instructors"
          rules=""
        />
      </v-col>
      <v-col cols="12" md="6">
        <data-selector
          v-model="operatingDay.instructor_igp_id"
          field-name="instructor_igp_id"
          source-type="instructors"
          rules=""
        />
      </v-col>
      <v-col cols="12" md="6">
        <data-selector
          v-model="operatingDay.tow_pilot_id"
          field-name="tow_pilot_id"
          source-type="users"
          rules=""
        />
      </v-col>
      <v-col cols="12" md="6">
        <data-selector
          v-model="operatingDay.timer_operator_id"
          field-name="timer_operator_id"
          source-type="users"
          rules=""
        />
      </v-col>
      <v-col cols="12" md="6">
        <data-selector
          v-model="operatingDay.rope_puller_id"
          field-name="rope_puller_id"
          source-type="users"
          rules=""
        />
      </v-col>
      <v-col cols="12">
        <validated-text-field
          v-model="operatingDay.comment"
          field-name="comment"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="operatingDay.coordinator_change_log && operatingDay.coordinator_change_log.length > 0"
      class="pb-2"
    >
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            {{ $t('coordinator_change_log') }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list dense>
              <template>
                <div v-for="(element, i) in operatingDay.coordinator_change_log" :key="i">
                  <v-divider />
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ element.date | dateTimeFormat }} - {{ element.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </template>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
  import DateField from '@/components/DateField'
  export default {
    name: 'EditOperatingDay',
    components: {
      DateField,
    },
    props: {
      operatingDay: Object,
    },
  }
</script>
